
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movies/details/[movieTitle]/[movieId]",
      function () {
        return require("private-next-pages/movies/details/[movieTitle]/[movieId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/movies/details/[movieTitle]/[movieId]"])
      });
    }
  